import React from 'react';

export const NutritionDashboardSkeleton: React.FC = () => {
    return (
        <div className="min-h-screen bg-background-dark pb-20 relative overflow-hidden animate-in fade-in duration-700">

            {/* AMBIENT GLOW */}
            <div className="absolute inset-0 z-0 pointer-events-none">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[150%] h-[800px] bg-primary/5 blur-[120px] rounded-full"></div>
            </div>

            {/* HEADER SKELETON WITH SHIMMER */}
            <header className="relative z-10 p-6 pt-12 mb-4">
                <div className="relative pl-6 space-y-4">
                    {/* Left Accent Line */}
                    <div className="absolute left-0 top-1 bottom-1 w-[3px] bg-primary/20 rounded-full animate-pulse"></div>

                    {/* Badge */}
                    <div className="w-28 h-7 bg-white/5 rounded-full overflow-hidden relative">
                        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
                    </div>

                    {/* Title */}
                    <div className="w-56 h-10 bg-white/5 rounded-xl overflow-hidden relative">
                        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
                    </div>

                    {/* Subtitle */}
                    <div className="w-40 h-5 bg-white/5 rounded-md overflow-hidden relative">
                        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
                    </div>

                    {/* Tags */}
                    <div className="flex gap-2 mt-4">
                        <div className="w-24 h-8 bg-white/5 rounded-lg overflow-hidden relative">
                            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
                        </div>
                        <div className="w-32 h-8 bg-white/5 rounded-lg overflow-hidden relative">
                            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
                        </div>
                    </div>
                </div>
            </header>

            {/* MACRO CARDS SKELETON - TRANSLUCENT PREMIUM */}
            <div className="grid grid-cols-4 gap-3 px-6 mb-10 relative z-10">
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="bg-surface-card/20 backdrop-blur-md border border-white/5 rounded-2xl p-4 flex flex-col items-center gap-3 aspect-[4/5] justify-center overflow-hidden relative shadow-lg">
                        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/5 to-transparent border-t border-l border-white/5 mix-blend-overlay"></div>
                        <div className="w-8 h-8 rounded-full bg-white/5"></div>
                        <div className="w-12 h-7 rounded-md bg-white/10 mt-1"></div>
                        <div className="w-8 h-3 rounded-sm bg-white/5 mt-auto"></div>
                    </div>
                ))}
            </div>

            {/* MEAL LIST SKELETON - SMOOTH SILHOUETTES */}
            <div className="px-6 space-y-6 relative z-10">
                {[1, 2, 3].map((i) => (
                    <div key={i} className="bg-surface-card/20 backdrop-blur-xl border border-white/5 rounded-[2.5rem] p-4 overflow-hidden relative shadow-2xl">
                        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/5 to-transparent mix-blend-overlay"></div>

                        {/* Header */}
                        <div className="p-4 pb-2 flex justify-between items-start">
                            <div className="space-y-3 flex-1 pr-4">
                                <div className="w-20 h-5 bg-white/5 rounded-md"></div>
                                <div className="w-full h-8 bg-white/10 rounded-lg"></div>
                                <div className="w-24 h-4 bg-white/5 rounded-sm"></div>
                            </div>
                            <div className="w-12 h-12 rounded-2xl bg-white/10 shrink-0 shadow-inner"></div>
                        </div>

                        {/* Image Placeholder */}
                        <div className="w-full h-48 bg-black/20 mt-4 mx-auto rounded-[2rem] border border-white/5" />

                        {/* Action Bar */}
                        <div className="pt-6 flex gap-3">
                            <div className="flex-1 h-14 bg-white/5 rounded-[1.5rem]"></div>
                            <div className="w-14 h-14 bg-white/5 rounded-[1.5rem]"></div>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
};
